/* eslint-disable react-hooks/exhaustive-deps */
import  { useState, useEffect } from "react";
import { useParams, useNavigate } from 'react-router-dom';
import Spreadsheet from "react-spreadsheet"; // , { createEmptyMatrix }
import * as ReactDOM from 'react-dom';
import { APIEndpoint } from "../../../utils/axios";
import {AlertModal } from "../../../common";
import { validateCellAndGetData } from "../../../utils/commonFunctions";
import { DEFAULT_SHEET_ROWS, defaultCellFieldData } from "../../../utils/configs";
import { useTranslation } from "react-i18next";
import { RiDeleteBin6Line } from "react-icons/ri";
import { FaRegCheckSquare,FaSave} from "react-icons/fa";
import { BiSolidSelectMultiple } from "react-icons/bi";
import closeIcon from "../../../images/icons/Icon2.png"

const iIndexes = {
    ITEM_CODE: 0,
    ITEM_NAME: 1,
    ITEM_UNIT: 2,
    ITEM_SENT_QTY: 3,
    ITEM_RECEIVED_QTY: 4,
    ITEM_QTY: 5,
    ITEM_REMARKS: 6
};
const sheetLabels = ['Item Code', 'Item Name', 'Unit', 'Sent', 'Received', 'Quantity', 'Remarks'];

const createEmptySheetRows = (noOfRows = DEFAULT_SHEET_ROWS) => {
    const rows = [];
    for( var i=0; i < noOfRows; i++) {
        rows.push([
            {
                ...defaultCellFieldData,
                id: 'itemCode',
                className: 'cellClass cellClass_' + i + '_' + iIndexes.ITEM_CODE,
                showPopup: false,
                readOnly: true
            },
            {
                ...defaultCellFieldData,
                id: 'itemName',
                className: 'cellClass cellClass_' + i + '_' + iIndexes.ITEM_NAME +' fixedfields',
                showPopup: false,
                readOnly: true
            },
            {
                ...defaultCellFieldData,
                id: 'unit',
                className: 'cellClass cellClass_' + i + '_' + iIndexes.ITEM_UNIT+' fixedfields',
                width: '400px',
                readOnly: true,
            },
            {
                ...defaultCellFieldData,
                id: 'sent',
                className: 'cellClass cellClass_' + i + '_' + iIndexes.ITEM_SENT_QTY+' fixedfields',
                readOnly: true,
                required: false
            },
            {
                ...defaultCellFieldData,
                id: 'receivedQuantity',
                className: 'cellClass cellClass_' + i + '_' + iIndexes.ITEM_RECEIVED_QTY+' fixedfields',
                readOnly: true,
                required: false
            },
            {
                ...defaultCellFieldData,
                type: 'number',
                id: 'grnQuantity',
                className: 'cellClass cellClass_' + i + '_' + iIndexes.ITEM_QTY,
                required: true
            },
            {
                ...defaultCellFieldData,
                id: 'remarks',
                className: 'cellClass cellClass_' + i + '_' + iIndexes.ITEM_REMARKS,
                required: true
            }
        ]);
    }
    return rows;
}

/**
 * Automatically creating rows
 */
// const initialData = createEmptyMatrix(10, sheetLabels.length);
/**
 * Manually creating rows
 */
const initialData = createEmptySheetRows( DEFAULT_SHEET_ROWS );

export const WarehouseTransfersGRNCreate = (props) => {
    const urlParams = useParams();
    const navigate = useNavigate();
    const { t } = useTranslation();

    const [editTransferDetails, setEditTransferDetails] = useState({});
    const [state, setState] = useState({ isInvalidAccess: false, message: '', isEditForm: false });
    const [count, setCount] = useState(1);
    const [isDragging, setIsDragging] = useState(false);
    const [dragStartRow, setDragStartRow] = useState(null);
    const [dragEndRow, setDragEndRow] = useState(null);
    const [isSaving,setIsSaving] = useState(false);

    const [sheetData, setSheetData] = useState(initialData);
    const [spreadsheetErrors, setSpreadsheetErrors] = useState([]);
    const modelStyle = { maxWidth: '50%', margin: 'auto 10% 100% 10%' };
    const [activeCell, setActiveCell] = useState({});

useEffect(() => {
    if (urlParams.transferId) {
        setState(prev => ({ ...prev, isEditForm: true }));
        getEditTransferDetailsById(urlParams.transferId);
        if (urlParams.warehouseId) {
            getWarehouseItems(urlParams.warehouseId);
        }
    }
}, [urlParams.transferId, urlParams.warehouseId]);

    useEffect( () => {
        if (Object.keys(editTransferDetails).length > 0) {
            setEditTransferItemsToSheet(editTransferDetails);
          
        }
    }, [editTransferDetails]);

    useEffect(() => {
const handleMouseMove = (e) => {
    if (!activeCell || dragStartRow === null) return;

    const hovered = document.elementFromPoint(e.clientX, e.clientY);

    if (!hovered) return;

    // Fix: className
    const className = typeof hovered.className === 'string' 
        ? hovered.className 
        : hovered.className?.baseVal ?? '';
    
    const match = className.match(/cellClass_(\d+)_(\d+)/);

    if (match) {
        const row = Number(match[1]);
        const col = Number(match[2]);

        if (col === iIndexes.ITEM_QTY) {
            setIsDragging(true);
            setDragEndRow(row);
        }
    }
};

  const handleMouseUp = () => {
    if (!isDragging) return;

    applyDragFill();

    setIsDragging(false);
    setDragStartRow(null);
    setDragEndRow(null);
  };

  window.addEventListener("mousemove", handleMouseMove);
  window.addEventListener("mouseup", handleMouseUp);

  return () => {
    window.removeEventListener("mousemove", handleMouseMove);
    window.removeEventListener("mouseup", handleMouseUp);
  };
}, [activeCell, dragStartRow, dragEndRow, isDragging]);

const applyDragFill = () => {
  if (dragStartRow === null || dragEndRow === null) return;

  const start = Math.min(dragStartRow, dragEndRow);
  const end = Math.max(dragStartRow, dragEndRow);

  const sourceValue =
    sheetData[dragStartRow][iIndexes.ITEM_QTY]?.value;

  if (sourceValue === '' || sourceValue == null) return;

  const updated = sheetData.map((row, rowIndex) => {
    if (rowIndex >= start && rowIndex <= end) {
      const newRow = [...row];
      newRow[iIndexes.ITEM_QTY] = {
        ...newRow[iIndexes.ITEM_QTY],
        value: sourceValue
      };
      return newRow;
    }
    return row;
  });

  setSheetData(updated);
};

    const getWarehouseItems = (sourceWarehouseId) => {
        APIEndpoint.post('warehouses/items', { warehouseId: sourceWarehouseId })
       .then(() => {})
        .catch( error => {
            console.log('Invalid page access!, Warehouse transfer details not found for given ID.', error.message);

            setState(prev => ({ ...prev, isInvalidAccess: true,
                message: "Invalid page access!, Warehouse transfer details are not found, On click OK, you will be redirected to Warehouse Transfer page." }));
        });
    };

    const getEditTransferDetailsById = (transferId) => {
        APIEndpoint.get('warehouseTransfers/findById/' + transferId )
        .then( resp => {
            if (resp) {
                const warehouseTransferDetails = resp.data;
                setEditTransferDetails(warehouseTransferDetails);
            }
        })
        .catch( error => {
            console.log('Invalid page access!, Warehouse transfer details not found for given ID.', error.message);

            setState(prev => ({ ...prev, isInvalidAccess: true,
                message: "Invalid page access!, Warehouse transfer details are not found, On click OK, you will be redirected to Warehouse Transfer page." }));
        });
    };

    const setEditTransferItemsToSheet = (transferDetails) => {
        let jsonSpreadsheetData = JSON.stringify( sheetData );
        let updatedSpreadsheetData = JSON.parse(jsonSpreadsheetData);
        const items = transferDetails.items;

        items.forEach( (item, i) => {
            updatedSpreadsheetData[i][iIndexes.ITEM_CODE].value = item.itemCode;
            updatedSpreadsheetData[i][iIndexes.ITEM_NAME].value = item.itemName;
            updatedSpreadsheetData[i][iIndexes.ITEM_UNIT].value = item.unit;
            updatedSpreadsheetData[i][iIndexes.ITEM_SENT_QTY].value = item.quantity;
            updatedSpreadsheetData[i][iIndexes.ITEM_RECEIVED_QTY].value = item.receivedQuantity;
            updatedSpreadsheetData[i][iIndexes.ITEM_QTY].value = '';
            updatedSpreadsheetData[i][iIndexes.ITEM_REMARKS].value = '';
        });

        ReactDOM.flushSync( () => {
            setSheetData( [ ...updatedSpreadsheetData ]);

        });

    };

    const addRowsToSheet = (rowsToAdd = 10) => {
        const newRows = createEmptySheetRows(rowsToAdd);
        setSheetData( [...sheetData, ...newRows ]);
    };


    const removeRow = (e) => {
        let jsonSpreadsheetData = JSON.stringify( sheetData );
        let inSheetData = JSON.parse(jsonSpreadsheetData);
        setSpreadsheetErrors([]);
        if(count%2 === 0){
            const newRows = createEmptySheetRows(10,[]);
            setSheetData([...newRows])
        }else{
            let row = activeCell.row;
            let deletedData = inSheetData.filter((data, index) => index !== row);
            ReactDOM.flushSync( () => {
                setSheetData([ ...deletedData ]);
            });
        }

    };


    const showValidationErrors = (e, inSheetData, errorClass='cellDataErrorCls' ) => {
        let haveErrors = false;
        let invalidRowsCount = 0;
        let dataRowsCount = 0;
        const postItems = [];

        inSheetData.forEach( (cellRow, rowIdx) => {

            let isRowHaveError = false;


            const itemCode = validateCellAndGetData(cellRow[iIndexes.ITEM_CODE]);
            const itemName = validateCellAndGetData(cellRow[iIndexes.ITEM_NAME]);

            if (!itemCode || !itemName ) {
                return cellRow;
            }
            ++dataRowsCount;

            let isThisRowHaveErrors = false;
            for (let colIdx = 0; colIdx < Object.keys(iIndexes).length; colIdx++) {


                if ( cellRow[colIdx].required === true) {

                    const fieldValue = validateCellAndGetData(cellRow[colIdx]);

                    if ( !fieldValue ) {

                        haveErrors = true;
                        isRowHaveError = true;
                        isThisRowHaveErrors = true;
                    }

                }

            }
            if (isThisRowHaveErrors) {
                ++invalidRowsCount;
            }

            if ( !isRowHaveError ) {

                const item = editTransferDetails.items.find( row => row.itemCode === cellRow[iIndexes.ITEM_CODE].value );
                if (item) {
                    postItems.push({
                        ...item,
                        _id: item._id,
                        index: rowIdx,
                        grnQuantity: parseInt(cellRow[iIndexes.ITEM_QTY].value),
                        remarks: cellRow[iIndexes.ITEM_REMARKS].value,
                    });

                }


            }

         
        });

        if (haveErrors) {
            setSpreadsheetErrors([ { message: 'Please fill all required item details.' } ]);
        }

        return {
            sheetData: inSheetData,
            validRows: postItems,
            haveErrors,
            invalidRowsCount,
            dataRowsCount
        };

    };

    const selectAllCells = (e) => {
        setCount((prev)=>prev+1)
        let updatedSheetData=[]
        let isFixedfieldsExist=false;
        if(count%2!==0){
            updatedSheetData = sheetData.map((row, rowIndex) => {
                return row.map((cell, colIndex) => {
                    isFixedfieldsExist = cell.className?.includes('fixedfields');
                    return {
                        ...cell,
                        className: `selectcell-class cellClass cellClass_${rowIndex}_${colIndex}${isFixedfieldsExist ? ' fixedfields' : ''}`
                    };
                });
            });
        }else{
            updatedSheetData = sheetData.map((row, rowIndex) => {
                return row.map((cell, colIndex) => {
                    isFixedfieldsExist = cell.className?.includes('fixedfields');
                    return {
                        ...cell,
                        className: `cellClass cellClass_${rowIndex}_${colIndex}${isFixedfieldsExist ? ' fixedfields' : ''}`
                    };
                });
            });
        }

    setSheetData(updatedSheetData);

    };

    const saveSheetData = (e) => {
        setSpreadsheetErrors([]);
        setIsSaving(true);
        let inSheetData = Object.assign([], sheetData);

        const respArrayData = showValidationErrors(e, inSheetData);

        if (!spreadsheetErrors.length && respArrayData.validRows.length === 0) {
            // show global alert message
            setSpreadsheetErrors([ ...spreadsheetErrors, { message: 'We did not find anything to save!' } ]);
            setIsSaving(false);
            return false;
        }

        if ( respArrayData.haveErrors ) {
            setIsSaving(false);
            return false;
        }

        if ( !respArrayData.validRows.length ) {
            setIsSaving(false);
            return false;
        }


        const data = {
            id: urlParams.transferId || '',
            warehouseId: parseInt(urlParams.warehouseId) || '',
            items: respArrayData.validRows || []
        }

        APIEndpoint.post('warehouseTransfer/saveGrn', data)
        .then( apiResp => {
            /**
             * Update success response
             */
            setSheetData(initialData);
            setSpreadsheetErrors([ ...spreadsheetErrors, { message: apiResp.msg || 'Successfully created GRN for Warehouse Transfer.' } ]);
            setTimeout( () => {
                goToModuleHome();
            }, 4000);
        })
        .catch( (error) => {
            const apiData = error.data;
            setSpreadsheetErrors([]);

            ReactDOM.flushSync( () => {
                console.log("Error occured while creating GRN for transfer:", apiData);
                if ( apiData.errors ) {
                    const errorMsg = apiData.errors.errors[0].message;
                    console.log('apiData.errors.errors: ', errorMsg);
                    setSpreadsheetErrors([ { error: errorMsg } ]);
                }
                else if (apiData.msg) {
                    setSpreadsheetErrors([ { error: apiData.msg} ]);
                }
                else {
                    setSpreadsheetErrors([ { error: 'Something went wrong, please try again later!' } ]);
                }
            });
            setIsSaving(false);
        });

        return false;
    };


    const handleActiveCellChange = (activeCell) => {
        setActiveCell({});
        console.log('ActiveCell:', activeCell);
        setActiveCell(activeCell);
        if (activeCell.column === iIndexes.ITEM_QTY) {
    setDragStartRow(activeCell.row);
  }
    }

    const handleCellKeyDown = (keyboardEvent) => {
        console.log('keyDownEvent.', keyboardEvent.target.value );

        if (activeCell && Object.keys(activeCell).length > 0) {
            if (sheetData[activeCell.row][activeCell.column].type === 'number' &&  keyboardEvent.target.value ) {
                keyboardEvent.target.value = keyboardEvent.target.value.replace(/[^0-9]$/g, '');
            }
        }
    }


    const goToModuleHome = () => {
        navigate('/procurement/warehouse-transfers');
    };
    const handleOnContinue = async () => {
        goToModuleHome();
    }

    return (
        <>
            <div className="op-aircraft-container flexCol full-flex ag-theme-alpine-dark">

                <div className="sheet-container sm-scrollbar">
                    <div className="header mb-3 flexRow justifyContentSpaceBetween">
                        <div className="leftBlock alignItemsCenter">
                            <button onClick={ (e) => saveSheetData(e) } disabled={isSaving}
                                className="add-item-button mr-2"><FaSave style={{marginRight:'5px',marginBottom:"3px"}}/>{ t('buttons.save') }</button> &nbsp;&nbsp;
                                <button   onClick={ (e) => selectAllCells(e) }
                                className="alignItemsCenter margRight10 flexRow add-item-button-all">{count%2===0?<BiSolidSelectMultiple  style={{marginRight:'5px'}} />:<FaRegCheckSquare  style={{marginRight:'5px'}} />}Select All</button>
                           
                            <button onClick={ (e) => removeRow(e) }
                                className="remove-button ml-2"> <RiDeleteBin6Line style={{ marginRight: "5px" ,marginBottom:"3px" }} />{ t('buttons.deleteRows') }</button>
                        </div>

                        {spreadsheetErrors.length >= 1? <div className={`padding4 margTop9-5 alert alert-${spreadsheetErrors[0].message.includes('successfully') ? 'success' : 'danger'}`}>
                        {spreadsheetErrors.length >= 1 ? spreadsheetErrors[0]?.message : null}
                        </div>:null}
                        <button onClick={goToModuleHome}>
                            <img src={closeIcon} alt="close" data-icon='close'/>
                        </button>
                    </div>

                    <div className="se-titlebar"><h6>Warehouse Transfer - {state.isEditForm === true ? editTransferDetails.code : 'New*' }</h6></div>

                    <Spreadsheet
                         className='spread-sheet'
                        data={sheetData}
                        columnLabels={sheetLabels}
                        darkMode={true}
                        onChange={setSheetData}
                        onActivate={handleActiveCellChange}
                        onKeyDown={handleCellKeyDown}
                    />

                   <div className="flexRow alignItemsCenter margTop8">
                        <button onClick={ () => addRowsToSheet() }
                            className="add-item-button" title={ t('spreadsheet.addmoreRows') }>{ t('buttons.addRows') }</button>
                    </div>

                </div>

                {
                    Boolean(state.isInvalidAccess) && (
                    <AlertModal
                        title={'Alert: Invalid Access'}
                        customModalStyle={ modelStyle }
                        description={ state.message }
                        onContinue={handleOnContinue}
                        onClose={handleOnContinue}
                    />
                    )
                }

            </div>
        </>
    );
}